import React, { useState, useEffect } from "react";
import { GoogleGenerativeAI } from "@google/generative-ai";
import { useSpring, animated, SpringValue } from "@react-spring/web"; // Import useSpring and animated

import ChatBox from "./ChatBox";
import Navbar from "./Navbar";

const App: React.FC = () => {
  const [generatedResponse, setGeneratedResponse] = useState<string>("");
  const [generativeModel, setGenerativeModel] = useState<any | null>(null);
  const [introVisible, setIntroVisible] = useState(false);

  // Use useSpring to animate the intro
  const introAnimation = useSpring({
    opacity: introVisible ? 1 : 0,
    transform: introVisible ? "translateY(0)" : "translateY(-10px)",
  });

  useEffect(() => {
    // Replace 'YOUR_API_KEY' with your actual Gemini API key
    const apiKey = "AIzaSyDp0Oji17ZQ7dds8ODNFO1DaQ_oJ0ooEoc";

    if (apiKey) {
      const genAI = new GoogleGenerativeAI(apiKey);

      const model = genAI.getGenerativeModel({
        model: "gemini-pro",
      });
      setGenerativeModel(model);
      // Sample initial user message
      const initialUserMessage =
        "Give me a short text asking me about my day and orienting me towards self-reflection subtly as if you are my personal ai diary. Start with Hello there!, Hey there! or Hi there! Maximum 4 sentences long, and let the user lead the conversation using Cognitive Behavioural Therapy.";
      handleSendMessage(initialUserMessage, model);
    } else {
      console.error("API key is missing. Please set your Gemini API key.");
    }
  }, []);

  const handleSendMessage = async (message: string, model: any) => {
    try {
      const userMessage =
        "Using a conversation tone and in maximum three sentences respond to my message below and encourage more introspection and kind reflection. assume that you are leading the user by using principles of cognitive Behavioural therapy-- don't reference the above context in your response, message:" +
        message;
      const result = await model.generateContent(userMessage);
      const response = await result.response;
      const text = response.text();
      setGeneratedResponse(text);
      setIntroVisible(true); // Set introVisible to true after generating the response
    } catch (error) {
      console.error("Error generating content:", error);
    }
  };

  return (
    <div className="bg-slate-900 h-screen ">
      {/* Stage 1: Simple background */}
      <animated.div
        style={{
          opacity: introAnimation.opacity.interpolate((o) => 1 - o),
          height: "",
          backgroundColor: "slategray", // You can customize the background color
        }}
      >
        {/* You can customize the content for Stage 1 if needed */}
      </animated.div>

      {/* Stage 2: Animated content */}
      <animated.div
        style={introAnimation as Record<string, SpringValue<number | string>>}
        className="p-4 md:px-20 xl:px-40"
      >
        <div className="flex flex-col ">
          <Navbar
            days={["Day 1"]}
            onAddDay={() => console.log("Add a new day")}
          />
          <div className="grid mt-12 text-4xl font-bold place-content-center text-white bg-slate-900">
            AI Diary
          </div>
          <div className="mb-8 text-slate-50 mt-12 border-2 rounded-md p-4">
            <strong className="grid  place-content-center">
              AI-Assisted Prompt:
            </strong>
            <p>{generatedResponse}</p>
          </div>
          <ChatBox
            onSendMessage={handleSendMessage}
            generativeModel={generativeModel}
            generatedResponse={generatedResponse}
          />
        </div>
      </animated.div>
    </div>
  );
};

export default App;
